import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ensureLocale } from "@/i18n";

// Synchronise la langue i18n avec le préfixe de route :
//  /en/...  → anglais (charge le chunk EN si nécessaire)
//  autres   → français
// Placé une seule fois dans le <Router>, ce composant évite d'envelopper
// chaque route. Les composants de page utilisent useTranslation() et
// s'affichent donc dans la langue courante.
//
// Persistance : on met à jour localStorage pour qu'un visiteur revenant
// sur la racine FR garde son choix s'il navigue manuellement vers /en.
export default function LanguageSync() {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const isEn = location.pathname.startsWith("/en");
    const target = isEn ? "en" : "fr";
    try {
      localStorage.setItem("tchatix-lang", target);
    } catch {
      /* ignore */
    }
    if ((i18n.language || "fr").startsWith(target)) return;
    ensureLocale(target).then(() => i18n.changeLanguage(target));
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}